module.exports = __webpack_public_path__ + "img/interv-bot.986aadcb.svg";